import { render, staticRenderFns } from "./EmpleadoPuestos.vue?vue&type=template&id=173b2d02&scoped=true"
import script from "./EmpleadoPuestos.vue?vue&type=script&lang=js"
export * from "./EmpleadoPuestos.vue?vue&type=script&lang=js"
import style0 from "./EmpleadoPuestos.vue?vue&type=style&index=0&id=173b2d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173b2d02",
  null
  
)

export default component.exports